var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apart",class:{
    'is-hoverable': _vm.isHoverable,
    'is-centered': _vm.isCentered,
    'is-wrapped': _vm.wrap
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }